import "./App.css";
import { useEffect } from "react";
import {
  browserName,
  deviceType,
  fullBrowserVersion,
  isDesktop,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from "react-device-detect";
import axios from "axios";
import moment from "moment";
import useGeoLocation from "react-ipgeolocation";
import TaobaoLoading from "./taobaoLoading.gif";

function App() {
  const location = useGeoLocation();

  useEffect(() => {
    if (!location.isLoading) redirectToTaobao();
  }, [location.isLoading]);

  const redirectToTaobao = async () => {
    try {
      console.log(location.country);

      const searchParams = new URLSearchParams(window.location.search);

      await axios.post(
        process.env.REACT_APP_LOGGING_URL,
        {
          deviceType: deviceType,
          osName: osName,
          osVersion: osVersion,
          browserName: browserName,
          fullBrowserVersion: fullBrowserVersion,
          mobileVendor: mobileVendor,
          mobileModel: mobileModel,
          country: location.country,
          url: window.location.href,
          isOffline: searchParams.has("offline"),
          date: moment(new Date()).utcOffset("+0800").format(),
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    } finally {
      if (isDesktop) {
        window.location.href =
          "https://huodong.taobao.com/wow/a/act/tao/dailygroup/23509/24308/wupr?wh_pid=daily-561999&disableNav=YES&status_bar_transparent=true";
      } else {
        window.location.href =
          // "https://intl.taobao.com/dp?h5Url=https%3A%2F%2Faff.world.taobao.com%2F_w.zcsQy&spm=offline.store";
          "https://aff.world.taobao.com/_b.Vdt9";
        // "https://world.taobao.com/wow/tmg-fc/tmw/offline-landing-new?sk=_b.Vdt9&targetUrl=https%3A%2F%2Fworld.taobao.com%2Fwow%2Ftmg-fc%2Fact%2Ftmw%2Fchannel%2F18335%2F18981%2Fwupr%3Fwh_pid%3DchannelPage-550577";
      }
    }
  };

  return (
    <div
      className="App"
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={TaobaoLoading} />
    </div>
  );
}

export default App;
